export let QboCustomerStatus = /*#__PURE__*/function (QboCustomerStatus) {
  QboCustomerStatus["Active"] = "Active";
  QboCustomerStatus["Archived"] = "Archived";
  QboCustomerStatus["Unknown"] = "Unknown";
  return QboCustomerStatus;
}({});
export class QboCustomerModel {
  static fromDTO(dto) {
    return new QboCustomerModel(dto);
  }
  constructor(data) {
    this.data = data;
  }
  id() {
    return this.data.id;
  }
  customerName() {
    return this.data.customerName;
  }
  contactName() {
    return this.data.contactName;
  }
  displayName() {
    return this.data.displayName;
  }
  formattedDisplay() {
    return "".concat(this.data.displayName, " (").concat(this.data.customerName, ")");
  }
  emailAddress() {
    return this.data.emailAddress;
  }
}